module.exports = __webpack_public_path__ + "static/NeueEinstellungBlack-31d67ff8262d990464feb7c535331f91.woff";